import SelectField from './select'

export default SelectField


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-formit-fields/src/components/select/index.js
// module id = null
// module chunks = 